import { useT } from "@transifex/react";
import type { Moment } from "moment";
import { ButtonColorVariant } from "../../complex/teacherArea/AreaButton";
import ShareDetailsStep from "../../complex/shareFlow/steps/ShareDetailsStep";
import type { ShareModes } from "../../enums/shareFlow";
import type { DetailHandlers } from "../../hooks/useTestOperations";
import BasePopupWrapper, { TitleColorVariants } from "./BasePopupWrapper";

interface EditTestDetailsPopupProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => void;
    isSaving: boolean;

    selectedMode: ShareModes | null;
    message: string;
    showDeadline: boolean;
    deadlineValue: Moment | null;
    visibilityDate: Moment | null;
    showDuration: boolean;
    durationHours: string;
    durationMinutes: string;
    handlers: DetailHandlers;
}

const EditTestDetailsPopup = (props: EditTestDetailsPopupProps) => {
    const t = useT();

    const t_title = t("Edit details", { _tags: "ClassActivity, EditTestDetailsPopup" });
    const t_cancel = t("Cancel", { _tags: "ClassActivity, EditTestDetailsPopup" });
    const t_save = t("Save", { _tags: "ClassActivity, EditTestDetailsPopup" });

    const handleClose = () => {
        if (props.isSaving) return;
        props.onClose();
    };

    return (
        <BasePopupWrapper
            isOpen={props.isOpen}
            onClose={handleClose}
            title={t_title}
            titleColor={TitleColorVariants.DEFAULT}
            secondaryButton={{
                text: t_cancel,
                onClick: handleClose,
                disabled: props.isSaving,
                colorVariant: ButtonColorVariant.DEFAULT,
            }}
            primaryButton={{
                text: t_save,
                onClick: props.onSave,
                disabled: props.isSaving,
                colorVariant: ButtonColorVariant.DEFAULT,
            }}
        >
            <ShareDetailsStep
                selectedMode={props.selectedMode}
                message={props.message}
                showDeadline={props.showDeadline}
                deadlineValue={props.deadlineValue}
                visibilityDate={props.visibilityDate}
                showDuration={props.showDuration}
                durationHours={props.durationHours}
                durationMinutes={props.durationMinutes}
                disabled={props.isSaving}
                {...props.handlers}
            />
        </BasePopupWrapper>
    );
};

export default EditTestDetailsPopup;
